export default "__VITE_ASSET__8d7baaea__"